export const isTreatmentItemPaid = (item: any) => {
  if (!item) return false;
  if (item.paymentId) return true;
  const paid = item.paid;
  if (paid === true || paid === 1) return true;
  if (typeof paid === "string" && paid.trim().toLowerCase() === "true") {
    return true;
  }
  return false;
};

/** Unpaid items are always editable. Paid items only when Super Admin allows it. */
export const isTreatmentItemEditable = (
  item: any,
  allowPaidForSuperAdmin = false
) =>
  Boolean(item?._id) &&
  (!isTreatmentItemPaid(item) || allowPaidForSuperAdmin);

/** Delete stays blocked for paid items for everyone. */
export const isTreatmentItemDeletable = (item: any) =>
  Boolean(item?._id) && !isTreatmentItemPaid(item);
